import React from 'react'
import { Box, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { SocialIcon } from 'react-social-icons';

interface Props {
  url: string,
  padding: number,
  testId: string
}

const OrangeSocialIcon = ({url, padding, testId}: Props) => (
  <Box data-testid={testId} sx={{ px: padding }}>
    <SocialIcon bgColor='#ff6600' url={url}/>
  </Box>
)

const Footer = () => (
  <Box component="footer" sx={{ py: 1, px: 2 }} data-testid="footer">
    <Divider sx={{ px: 1, my: 2, opacity: 1 }}/>
    <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
      <OrangeSocialIcon 
        url="https://www.facebook.com/ietseneofficially" 
        testId="social-icon-facebook"
        padding={1}/>
      <OrangeSocialIcon 
        url="https://www.instagram.com/iets.ene" 
        testId="social-icon-instagram"
        padding={1}/>
      <OrangeSocialIcon 
        url="https://twitter.com/ietsene" 
        testId="social-icon-twitter"
        padding={1}/>
      <OrangeSocialIcon 
        url="https://www.tiktok.com/@ietsene.designs" 
        testId="social-icon-tiktok"
        padding={1}/>
    </Box>
    <Box sx={{ py: 2, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
      <Typography variant="body1" align="center">
        &copy; {new Date().getFullYear()} iets'ene Designs. All rights reserved.
      </Typography>
      <Typography
        component={Link}
        to="/privacy"
        align="center"
        sx={{ color: 'grey.600', fontSize: 14, textDecoration: 'underline' }}
      >
        Privacy Policy
      </Typography>
    </Box>
  </Box>
);

export default Footer